import styled from 'styled-components';
import { Button, Text } from '@kl/components-v6';
import { LocalizedText } from 'shared/ui/localized-text';

export const StyledChangeLanguageButton = styled(Button)`
    width: 100%;

    .kl-components-button-text {
        width: 100%;
    }
`;

export const StyledTriggerElementContainer = styled.div`
    width: 100%;
`;

export const StyledButtonText = styled(LocalizedText)`
    flex-grow: 1;
    text-align: left;
`;

export const StyledButtonContent = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
`;

export const StyledChangeLanguageText = styled(Text)`
    display: inline-flex;
    align-items: center;
    gap: 4px;
`;
